<template>
  <path
    data-name="Pfad 995"
    d="M12 0a12.007 12.007 0 0 0-1.6 23.906v-2.42a1.592 1.592 0 0 0-1.076-1.512A8.4 8.4 0 1 1 20.4 12.006c0 .105 0 .21-.006.314v.07q-.007.145-.018.289c0 .03-.005.061-.008.091q-.019.213-.049.425c0 .034-.009.068-.014.1-1.028 6.778-9.852 10.588-9.9 10.608A12.006 12.006 0 1 0 12 0z"
    fill-rule="evenodd"
  />
</template>
